import { Routes } from '@angular/router';
import { Home } from './features/home/home';
import { Ausschreibungen } from './features/ausschreibungen/ausschreibungen';
import { Ergebnisse } from './features/ergebnisse/ergebnisse';
import { Kontakt } from './features/kontakt/kontakt';
import { Vereine } from './features/vereine/vereine';
import { Impressum } from './features/impressum/impressum';
import { Login } from './features/admin/login/login';
import { Dashboard } from './features/admin/dashboard/dashboard';
import { Termine } from './features/termine/termine';
import { ShootingScheduleComponent } from './features/shooting-schedule/shooting-schedule';
import { CompetitionDatesComponent } from './features/competition-dates/competition-dates';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', component: Home, title: 'Home - SKO Süd' },
  { path: 'ausschreibungen', component: Ausschreibungen, title: 'Ausschreibungen - SKO Süd' },
  { path: 'ergebnisse', component: Ergebnisse, title: 'Ergebnisse - SKO Süd' },
  { path: 'kontakt', component: Kontakt, title: 'Kontakt - SKO Süd' },
  { path: 'vereine', component: Vereine, title: 'Vereine - SKO Süd' },
  { path: 'impressum', component: Impressum, title: 'Impressum - SKO Süd' },
  { path: 'termine', component: Termine, title: 'Termine - SKO Süd' },
  { path: 'shooting-schedule', component: ShootingScheduleComponent, title: 'Schießplan - SKO Süd' },
  { path: 'competition-dates', component: CompetitionDatesComponent, title: 'Wettkampftermine - SKO Süd' },
  { path: 'admin/login', component: Login, title: 'Admin Login - SKO Süd' },
  { path: 'admin/dashboard', component: Dashboard, title: 'Dashboard - SKO Süd', canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
